import React, {
  useState,
  useCallback,
  useMemo,
  useReducer,
  useEffect,
} from "react";

import "whatwg-fetch";
import Guid from "devextreme/core/guid";
import { useStyles } from "../../Styles.js";
import { useSearchParams } from "react-router-dom";
import Grid from "@material-ui/core/Grid";
import Container from "@material-ui/core/Container";
import { api_path } from "../../shared.js";
import Button from "@material-ui/core/Button";
import DupOrderDataview from "./DupOrderDataview";
export function SalesOrderDupOrderDataGrid(props) {
  const [searchParams] = useSearchParams();
  const duplicateid = searchParams.get("duplicateid");
  const [getCrmId, setCrmId] = useState(props.CRM_ID);
  const [getUserRole, setUserRole] = useState(props.USER_ROLE);
  const [getUserID, setUserID] = useState(props.USER_EMAIL);
  const [getEmpCode, setEmpCode] = useState(props.EMP_CODE);
  const [orderData, setOrderData] = useState([]);
  const [getLoadGrid, setLoadGrid] = useState();
  const [GET_OPEN_MODAL, SET_OPEN_MODAL] = useState(0);
  const pageSizes = [25, 50, 100];
  const classes = useStyles();

  useEffect(() => {
    fetchData();
  }, []);
  const fetchData = async () => {
    const response = await fetch(
      api_path + "/TS_SALES_ORDER_DUPLICATE.php?duplicateid=" + duplicateid
    );
    const data = await response.json();
    setOrderData(data);
  };
  const showCostData = true;
  function DisplayData(props) {
    if (props.orderData.length > 0) {
      return (
        <div className="">
          <table class="table table-Default table-hover">
            <thead>
              <tr>
                <th scope="col">SO NO.</th>
                <th scope="col">Quotation</th>
                <th scope="col">Customer Ref.</th>
                <th scope="col">20'</th>
                <th scope="col">20' Type</th>
                <th scope="col">20' GW</th>
                <th scope="col">40'</th>
                <th scope="col">40' Type</th>
                <th scope="col">40' GW</th>
                <th scope="col">40HQ'</th>
                <th scope="col">40HQ' Type</th>
                <th scope="col">40HQ' GW</th>
                <th scope="col">45'</th>
                <th scope="col">45' Type</th>
                <th scope="col">45' GW</th>
                <th scope="col">status</th>
                <th scope="col"></th>
                <th scope="col"></th>
                <th scope="col"></th>
              </tr>
            </thead>
            {showCostData ? (
              <>
                {orderData.map((fdata) => {
                  return (
                    <DupOrderDataview
                      key={fdata.ORDER_ID}
                      id={fdata.ORDER_ID}
                      ORDER_NO={fdata.ORDER_NO}
                      QUOTATION_NO={fdata.QUOTATION_NO}
                      CUSTOMER_REF={fdata.CUSTOMER_REF}
                      CNT20={fdata.CNT20}
                      TYPE20={fdata.TYPE20}
                      GW20={fdata.GW20}
                      CNT40={fdata.CNT40}
                      TYPE40={fdata.TYPE40}
                      GW40={fdata.GW40}
                      CNT40HQ={fdata.CNT40HQ}
                      TYPE40HQ={fdata.TYPE40HQ}
                      GW40HQ={fdata.GW40HQ}
                      CNT45={fdata.CNT45}
                      TYPE45={fdata.TYPE45}
                      GW45={fdata.GW45}
                      CARGO_READY={fdata.CARGO_READY}
                      ETD_DATE={fdata.ETD_DATE}
                      ETA_DATE={fdata.ETA_DATE}
                      RETURN_DATE={fdata.RETURN_DATE}
                      CY_DATE={fdata.CY_DATE}
                      USERID={getCrmId}
                      updateOrderData={updateOrderData}
                    />
                  );
                })}
              </>
            ) : (
              <p>You cannot see the data</p>
            )}
          </table>
        </div>
      );
    } else {
    }
  }
  function updateOrderData(id, NewPod, newDelivery, NewTotalPrice) {
    const updateOrderData = orderData.map((fdata) => {
      if (id == fdata.PORT_ID) {
        return {
          ...fdata,
          PORT_ID: id,
          POD: NewPod,
          DELIVERY: newDelivery,
          TotalPrice: NewTotalPrice,
        };
      }
      return fdata;
    });
    setOrderData(updateOrderData);
    fetchData();
  }
  const onEditClick = React.useCallback((e) => {
    window.open("/s-crm/SalesOrder");
  }, []);

  return (
    <Container maxWidth="xl">
      <Grid container spacing={2}>
        <Grid item xs={12}>
          &nbsp;
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <label className="head">Duplicate Order</label>
        </Grid>
        <Grid item xs={12} sm={3}></Grid>
      </Grid>

      <br />
      <Grid container className={classes.root}>
        <Grid item xs={12} sm={12}>
          <DisplayData orderData={orderData} />
        </Grid>

        <Grid
          item
          xs={12}
          sm={6}
          // style={{ display: "flex" }}
          //     justify="flex-end"
        >
          <Button
            type="button"
            variant="contained"
            color="primary"
            onClick={onEditClick}
          >
            Back to Sale Order page
          </Button>
        </Grid>
        <Grid item xs={12} sm={6}>
          &nbsp;
        </Grid>
      </Grid>
    </Container>
  );
}
